// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import Promise from 'es6-promise'
import api from './api/api'
import { apiGet, apiPost } from "@/fetch/api";
import VideoPlayer from 'vue-video-player';
import * as filter from './filters';
import Components from '@sditest/electronic-invoice-api';
require("video.js/dist/video-js.css")
require("vue-video-player/src/custom-theme.css")
Promise.polyfill()
Vue.config.productionTip = false
Vue.use(iView)
Vue.use(VideoPlayer)
Vue.prototype.filter = filter
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})
Vue.use(Components)

import {
  linkBaseUrl,
  pubUrl
} from "../config/index"

Vue.mixin({
  methods: {
    gotoTarget(item) {
      // let baseUrl = process.env.NODE_ENV == 'production' ? 'https://wap.lotsmall.cn' : 'http://testwap.lotsmall.cn';
      //let baseUrl = linkBaseUrl;
      let m_id = localStorage.getItem('m_id');
      let url = '';
      if (item.linkUrl == 'home') {
        // url = '/?m_id=' + m_id;
        router.push('/?m_id=' + m_id);
        // 如果当前是首页着不跳转       
      } else if (item.linkUrl == 'personal') {
        // url = '/member?m_id=' + m_id;
        router.push('/member?key=0&m_id=' + m_id);
      } else if (item.linkUrl == 'order') {
        // url = '/order/list?m_id=' + m_id;
        router.push('/order/list?key=1&m_id=' + m_id);
      }  else if (item.linkUrl == 'coupon') {
        router.push('/coupons/list?key=3&m_id=' + m_id);
        // url = '/coupons/list?m_id=' + m_id;
      } else if (item.linkUrl == 'receivecoupons') {
        router.push('/coupons/list?key=3&m_id=' + m_id);
      } else if (item.linkUrl == 'accountcenter') {
        router.push('/member?key=0&m_id=' + m_id);
        // url = '/member?m_id=' + m_id;
      }else if (item.linkUrl == 'information') {//资讯
        if (item.columnId && item.columnId.length){
          const news_id = item.columnId[item.columnId.length - 1]
          localStorage.setItem('news_id', news_id)
          localStorage.setItem('news_title', item.title)
          router.push('/newslist');
        }else{
          this.$Message.warning('请先去设置资讯链接'); 
        }
      } else if (item.linkUrl == 'customlink') {        
        let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/
        if (reg.test(item.customLinkurl)) {
          window.location.href = item.customLinkurl
        } else {
          let strUrl = '//' + item.customLinkurl
          window.location.href = strUrl
        }
        return;
      }  else if (item.linkUrl == 'theater') {
        apiGet(api.main.selectServiceUse, {
          "serviceType": "theater"
        }).then(res => {
          if (res.status == 200 && res.data.theater) {           
            router.push('/list/theatre?m_id=' + m_id);
          } else {
            this.$Message.warning('你还没有购买此服务或者你购买的此服务已过期');           
          }
        }).catch(e => {
          console.log(e);
        });
        return;
      } else if (item.linkUrl == 'ticket'||item.linkUrl == 'park'){
        router.push('/list/ticket?m_id=' + m_id);
      } else if (item.linkUrl == 'hotel'||item.linkUrl == 'pmsHotel'){
        router.push('/list/hotel?m_id=' + m_id);
      } else if (item.linkUrl == 'route'){
        router.push('/list/route?m_id=' + m_id);
      } else if (item.linkUrl == 'shop'){
        router.push('/list/shop?m_id=' + m_id);
      } else if (item.linkUrl == 'repast') {
        router.push('/list/eatery?m_id=' + m_id);
      } 
      // if (url) {
      //   window.location.href = baseUrl + url;
      // }
    }    
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js